import { useEffect, useState } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import PlatformSignIn from './pages/PlatformSignIn';
import Workspace from './pages/Workspace';
import { loadDemoData, saveDemoData } from './lib/demoRepository';

function DemoWorkspace() {
  const [data, setData] = useState(() => loadDemoData());
  const [page, setPage] = useState('overview');
  const [language, setLanguage] = useState('el');
  const [role, setRole] = useState('platform_owner');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (data) saveDemoData(data);
  }, [data]);

  if (!data) {
    return <PlatformSignIn />;
  }

  const pageContent = page === 'overview'
    ? <Dashboard data={data} language={language} navigate={setPage} />
    : page === 'organizations'
      ? <Organizations data={data} setData={setData} language={language} role={role} />
      : <Workspace page={page} data={data} setData={setData} language={language} role={role} />;

  return (
    <div className="app-shell" lang={language}>
      <Sidebar
        page={page}
        setPage={setPage}
        language={language}
        open={menuOpen}
        close={() => setMenuOpen(false)}
      />
      <main className="main-area">
        <Topbar
          page={page}
          language={language}
          setLanguage={setLanguage}
          role={role}
          setRole={setRole}
          onMenu={() => setMenuOpen(true)}
        />
        <div className="environment-banner">
          <span />
          <strong>DEMO MODE</strong> · fictional records · changes stay in this browser
        </div>
        {pageContent}
        <footer className="app-footer">
          <span>AcademyOS Platform · Demo build</span>
          <span>
            Europe/Athens · EUR · {import.meta.env.VITE_APP_VERSION || '0.1.0'}
          </span>
        </footer>
      </main>
    </div>
  );
}

function AppRoutes() {
  const demoEnabled = import.meta.env.VITE_APP_MODE === 'demo';

  if (!demoEnabled) {
    return (
      <Routes>
        <Route path="/login" element={<PlatformSignIn />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<PlatformSignIn demoAvailable />} />
      <Route path="*" element={<DemoWorkspace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  );
}